/**
 * Venue top-nav business-case tooltips.
 * Same job as Menu Builder: why to click, not a feature brochure.
 * Keep each line roughly Menu Builder length (Progress is plan-aware and shorter).
 */

import { MENU_BUILDER_NAV_TOOLTIP } from './menuBuilderNavCopy'
import { planDisplayName } from './planDisplay'

const planLabelForNav = plan => planDisplayName(plan, { short: true })

/**
 * Progress tab tooltip — plan name in the line so Lite / Pro / etc. feel owned.
 *
 * @param {string|null|undefined} plan
 * @returns {string}
 */
export function getVenueNavProgressTooltip(plan) {
  return `Help you get the most out of your ${planLabelForNav(
    plan,
  )} OMS account.`
}

export const VENUE_NAV_TOOLTIPS = Object.freeze({
  home: 'See what still needs doing at this venue — so you start from today’s work, not a blank list.',
  purchasing:
    'Receipt what arrived and match invoices — so spend, GP, and your numbers in OMS stay accurate.',
  progress: getVenueNavProgressTooltip('Free'),
  suppliers:
    'Add suppliers and control catalogue access — restrict lines or keep chefs on the shopping list.',
  catalogue:
    'Browse the full range, then add only what belongs on the shopping list — so staff don’t order the whole catalogue.',
  products:
    'Tell staff exactly what to order and how much — set par levels so the kitchen reorders the right amount.',
  stockTakes:
    'Count what’s on the shelf, then order the gap to par — so you buy what you actually need.',
  'food-safety':
    'See today’s Food Safety status across the kitchen — temps, checks, and what’s still outstanding.',
  'menu-builder': MENU_BUILDER_NAV_TOOLTIP,
  settings:
    'Manage users and keep venue details right — who can log in, their role, and the basics this site needs.',
  subscriptions:
    'See what this venue already has access to — your plan, limits, and what’s included on the account.',
  integrations:
    'Connect OMS to the platforms you already use — so invoices and accounts stay in one place.',
  'special-purchases':
    'Request spend outside day-to-day orders — repairs, uniforms, and other one-offs you need to track.',
  approvals:
    'See and action restricted-supplier orders waiting for your approval — no need to dig for the approval email.',
})

export const VENUE_NAV_TOOLTIP_KEYS = Object.freeze(
  Object.keys(VENUE_NAV_TOOLTIPS),
)
